export const PollCadence = {
	pipeline({ visible }: { visible: boolean }) {
		return visible ? 15_000 : false;
	},
};
